import ExistingMemberCard from "@/components/GetStarted/ExistingMemberCard";
import style from "@/styles/pages/ExistingMember/ExistingMember.module.css";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { createApiClient } from "@/lib/Requests";
import { useEffect, useState } from "react";
import FadeTransition from "@/styles/animation/FadeTransition";
import { setFinancialInstitutions, setOccupations } from "@/slices/sessionDataSlice";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { AmendMemmberCoApplicantCommand, RememberClientDto } from "@/lib/DTMWebAPIClient.generated";
import { americanStatesAbbreviationList, processUserAppData } from "@/lib/util";
import { setCredentialsCreated, setApplicantId, setFmApplicationId, setFmApplicantId, setTitle, setFirstName, setMiddleName, setLastName, setPhoneNumber, setPhoneType, setEmailAddress, setDateOfBirthYear, setDateOfBirthMonth, setDateOfBirthDay, setMaritalStatus, setNumOfDependents, setResidentStatus, setExistingMemberFields, setIsProspect } from "@/slices/applicantSlice";
import { setAddressId, setStreetNumber, setStreetName, setStreetDirection, setUnitType, setUnitNumber, setCity, setProvince, setPostalCode, setCountry, setStreetType } from "@/slices/homeAddressSlice";
import { setAMLFieldsCompleted } from "@/slices/legalTermsSlice";
import { streetTypes } from "@/ts/streetTypes";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import { useAuth } from "@/context/AuthContext";


export default function SSOLoginROB() {
    const client = createApiClient({ timeout: 60000 });
    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const getAmericanStates = americanStatesAbbreviationList();
    const { login } = useAuth();

    // Get Query Parameters (productId)
    let ssoToken = "";

    useEffect(() => {

        ssoToken = (searchParams.get("token") != null) ? decodeURIComponent(searchParams.get("token") + "") : "";
        console.log("SSO Token: ", ssoToken);

        //Fetch New Token if it's valid
        if (ssoToken != "") {
            client.apiAuthSso(ssoToken).then((result) => {
                dispatch(setCredentialsCreated(true));
                dispatch(setIsProspect(false));
                login(result.accessToken != undefined ? result.accessToken : "", result.refreshToken != undefined ? result.refreshToken : "");
                let authenticatedClient = createApiClient({ timeout: 60000, token: result.accessToken });

                if (result.applicant) {
                    let applicantInfo = result.applicant;

                    //Check if this member's start date is less than 60 days; if so, redirect to error page
                    if (result.applicant?.startDate?.year() && result.applicant.startDate.year() > 1901) {
                        let today = dayjs();
                        if (today.diff(result.applicant.startDate, 'day') < 60) {
                            navigate("/error/1", { replace: true });
                            return;
                        }
                    }

                    let dobMonth = applicantInfo.dateOfBirth.month() + 1;
                    let dobDay = applicantInfo.dateOfBirth.date();

                    dispatch(setApplicantId(applicantInfo.id ? applicantInfo.id : 0));
                    dispatch(setFmApplicationId(applicantInfo.fmApplicationId ? applicantInfo.fmApplicationId : ""));
                    dispatch(setFmApplicantId(applicantInfo.fmApplicantId ? applicantInfo.fmApplicantId : ""));
                    dispatch(setTitle(applicantInfo.title ? applicantInfo.title : ""));
                    dispatch(setFirstName(applicantInfo.firstName));
                    dispatch(setMiddleName(applicantInfo.middleName ? applicantInfo.middleName : ""));
                    dispatch(setLastName(applicantInfo.lastName));
                    dispatch(setPhoneNumber(applicantInfo.phoneNumber));
                    dispatch(setPhoneType(applicantInfo.phoneType ? applicantInfo.phoneType.replace(/\w/, p => p.toUpperCase()) : ""));
                    dispatch(setEmailAddress(applicantInfo.email));
                    dispatch(setDateOfBirthYear(applicantInfo.dateOfBirth.year() + ""));
                    dispatch(setDateOfBirthMonth(dobMonth.toString().length == 1 ?
                        "0" + dobMonth.toString() : dobMonth.toString()));
                    dispatch(setDateOfBirthDay(dobDay + ""));
                    dispatch(setMaritalStatus(applicantInfo.maritalStatus ? applicantInfo.maritalStatus : ""));
                    dispatch(setNumOfDependents(applicantInfo.numberOfDependents ? applicantInfo.numberOfDependents : 0));

                    if (applicantInfo.address) {
                        dispatch(setAddressId(applicantInfo.address[0].id ? applicantInfo.address[0].id : 0));
                        dispatch(setStreetNumber(applicantInfo.address[0].streetNumber ? applicantInfo.address[0].streetNumber : ""));
                        dispatch(setStreetName(applicantInfo.address[0].streetName ? applicantInfo.address[0].streetName : ""));
                        dispatch(setStreetDirection(applicantInfo.address[0].streetDirection ? applicantInfo.address[0].streetDirection : ""));
                        dispatch(setUnitType(applicantInfo.address[0].unitType ? applicantInfo.address[0].unitType : ""));
                        dispatch(setUnitNumber(applicantInfo.address[0].unitNumber ? applicantInfo.address[0].unitNumber : ""));
                        dispatch(setCity(applicantInfo.address[0].city ? applicantInfo.address[0].city : ""));
                        //If the country is set to United States but the province/state does not match a US state, do not set the province value as it is likely a Canadian province that was not properly cleared
                        if (applicantInfo.address[0].country == "United States" && !getAmericanStates.includes(applicantInfo.address[0].region ? applicantInfo.address[0].region : "")) {
                            dispatch(setProvince(""));
                        } else {
                            dispatch(setProvince(applicantInfo.address[0].region ? applicantInfo.address[0].region : ""));
                        }
                        dispatch(setPostalCode(applicantInfo.address[0].postalCode ? applicantInfo.address[0].postalCode : ""));
                        dispatch(setCountry(applicantInfo.address[0].country));
                        dispatch(setResidentStatus(applicantInfo.address[0].residenceStatusType_Name ? applicantInfo.address[0].residenceStatusType_Name : ""));

                        //Attempt to parse the street type based on whether it contains multiple words
                        if ((applicantInfo.address[0].streetType == undefined || applicantInfo.address[0].streetType == "") && applicantInfo.address[0].streetName && applicantInfo.address[0].streetName.split(" ").length > 1) {
                            let streetNameComponents = applicantInfo.address[0].streetName.split(" ");
                            let newStreetName = "";
                            for (let i = 0; i < streetNameComponents.length - 1; i++) {
                                newStreetName += streetNameComponents[i] + " ";
                            }
                            let streetType = streetNameComponents[streetNameComponents.length - 1].toUpperCase();
                            dispatch(setStreetType(streetTypes.includes(streetType) ? streetType : ""));
                            dispatch(setStreetName(newStreetName.trim()));
                        } else if (applicantInfo.address[0].streetType != undefined && applicantInfo.address[0].streetType != "") {
                            dispatch(setStreetType(applicantInfo.address[0].streetType));
                        }
                    }

                    //Check Validity of Ovation Fields
                    let phoneNumberReg = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/);
                    dispatch(setExistingMemberFields({
                        isFirstNameAvailable: applicantInfo.firstName.trim() != '',
                        isLastNameAvailable: applicantInfo.lastName.trim() != '',
                        isPhoneNumberAvailable: phoneNumberReg.test(applicantInfo.phoneNumber),
                        isSinAvailable: true,
                        isProvinceAvailable: applicantInfo.address != undefined && applicantInfo.address[0].region ? applicantInfo.address[0].region.trim() != '' : false,
                        isPostalCodeAvailable: applicantInfo.address != undefined && applicantInfo.address[0].postalCode ? applicantInfo.address[0].postalCode.trim() != '' : false,
                        isCountryAvailable: applicantInfo.address != undefined && applicantInfo.address[0].country ? applicantInfo.address[0].country.trim() != '' : false
                    }));

                }

                authenticatedClient.apiApplicationsFetch().then(async (appData) => {
                    if (appData) {

                        //Prefil member info such as subject property, address, etc.
                        processUserAppData(appData, dispatch);
                        dispatch(setAMLFieldsCompleted(true));

                        if (result.docIqDestination == undefined || result.docIqDestination == "") {
                            navigate("/home", { replace: true });
                            return;
                        }
                    } else {
                        navigate("/confirm-consent", { replace: true });
                    }
                }).catch((error) => {
                    console.log("Error fetching application info", error);
                });
            }).catch((error) => {
                navigate("/error/4");
            });
        }

        client
            .apiDataOccupations()
            .then(function (data) {
                dispatch(setOccupations(data != null && data != undefined ? data : []));
            })
            .catch((error) => {
                navigate("/error/3");
            });
        client.apiDataFinancialinstitutions()
            .then(function (data) {
                dispatch(setFinancialInstitutions(data != null && data != undefined ? data : []));
            })
            .catch((error) => {
                navigate("/error/3");
            });
    }, []);

    return (
        <FadeTransition>
            <main aria-labelledby="main-content">
                <div className="main-container max-md:mt-10">
                    <div className={style.emHeading}>
                        <div className="grid grid-cols-1">
                            <FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: 28 }} />
                        </div>
                    </div>
                </div>
            </main>
        </FadeTransition>

    );
}